import { render, staticRenderFns } from "./editRoleManagement.vue?vue&type=template&id=dfe4e736&"
import script from "./editRoleManagement.vue?vue&type=script&lang=js&"
export * from "./editRoleManagement.vue?vue&type=script&lang=js&"
import style0 from "./editRoleManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports